$(function () {

	//動画ポップアップ表示
    // $('.popup-youtube').magnificPopup({
    //     type: 'iframe',
    //     iframe: {
    //         markup: '<div class="mfp-iframe-scaler">' +
    //             '<div class="mfp-close"></div>' +
    //             '<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
    //             '</div>',
    //         patterns: {
    //             youtube: {
    //                 index: 'youtube.com/',
    //                 id: 'v=',
    //                 src: 'https://www.youtube.com/embed/%id%?autoplay=1'
    //             }
    //         }
    //     }
    // });

    //動画ポップアップ表示
    $('.popup-modal').magnificPopup({
        type: 'inline',
        preloader: false
    });

    //冒頭スライダー
    var led_swiper = new Swiper('.led_swiper', {
		navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
	});

});